import React from "react";
import { useLang } from "@/lib/i18n";
import SeoLandingPage from "@/components/SeoLandingPage";
import { reinigingsregNL } from "@/data/seo-landing-pages";

const ReinigingsregistratieTransport = () => {
  const { lang } = useLang();
  return <SeoLandingPage data={reinigingsregNL} lang={lang} />;
};

export default ReinigingsregistratieTransport;
